module.exports = __webpack_public_path__ + "img/recuperado.4a0bd653.png";